module.exports = __webpack_public_path__ + "assets/3394ef54dd08b2f8c6b9f9e2bf9dc4bf.mp3";